import "./index.scss";
import { useState } from "react";
import { Modal } from "..";
import { EXTERNAL_LINKS } from "routes/paths";
import { ReactComponent as ArrowIcon } from "assets/arrow-icon.svg";
import { makeRedemptionInstructions } from "utils/strings";

export const BrandRedemptionDetails = ({
  terms,
  card: { cardDetails, deliveryAndRedemption: defaultDeliveryAndRedemption },
  name,
  isApple
}) => {
  const [popover, setPopover] = useState(false);

  const deliveryAndRedemption = isApple
    ? [
        ...defaultDeliveryAndRedemption,
        "The Apple Gift Card can be used two ways:"
      ]
    : defaultDeliveryAndRedemption;

  return (
    <div
      className="brand-redemption-details"
      data-testid="brand-redemption-details"
    >
      <button
        className="redemption-details-trigger"
        onClick={() => setPopover(true)}
      >
        <p>Redemption Details & Gift Card Terms</p>
        <ArrowIcon className="arrow-icon" />
      </button>
      <Modal customClassName="redemption-details-modal" isOpen={popover}>
        <button onClick={() => setPopover(false)}>&#x2715;</button>
        <header>
          <h3>About {name} cards</h3>
        </header>
        <section>
          <h4>DELIVERY &amp; REDEMPTION</h4>
          <ul>
            {deliveryAndRedemption.map(
              (text) => text && <li key={text}>{text}</li>
            )}
          </ul>
          {isApple && (
            <ol>
              <li>
                For online purchases, go to apple.com/redeem to add to your
                Apple Account balance.
              </li>
              <li>Bring the Apple Gift Card to any Apple Store location.</li>
            </ol>
          )}
        </section>
        <section>
          <h4>CARD DETAILS</h4>
          <ul>
            {cardDetails.map((text) => text && <li key={text}>{text}</li>)}
          </ul>
        </section>
        <section>
          <h4>Terms of Use</h4>
          <h5>GCX</h5>
          <p>
            All trademarks not owned by GCX that appear on this site are the
            property of their respective owners. GCX is not the issuer of any of
            the gift cards or other closed-loop products on GCX and is not
            related to any merchant whose trademark and gift cards appear on GCX
            for sale. All gift cards sold on our marketplace are backed by our
            90 Day Money-Back Guarantee.
          </p>
          {terms && (
            <>
              <h5>{name}</h5>
              <div>{makeRedemptionInstructions(terms)}</div>
            </>
          )}
        </section>
        <footer>
          <h4>
            For questions about redeeming gift cards, please visit our{" "}
            <a href={EXTERNAL_LINKS.MARKETPLACE_ZENDESK}>Help Center.</a>
          </h4>
        </footer>
      </Modal>
    </div>
  );
};
